<template>

    <div class="login-signup--wrap" @click.self="closeLoginForm">

        <div class="log-sig-form">
            <div class="close-loginsignup" @click="closeLoginForm" v-if="!signUpFailMessage">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </div>
            <div class="log-sig-tab" v-if="activeTab !== 'forgotpw' && !loginSuccesful && !signUpFailMessage">
                <h3 @click="activeTab = 'login'" :class="{'active': activeTab === 'login'}">Iniciar Sesión</h3>
                <h3 @click="activeTab = 'signup'" :class="{'active': activeTab === 'signup'}">Registrarse</h3>
            </div>

            <div class="login-wrap" v-if="activeTab === 'login'">
                <div v-if="!loginSuccesful">
                    <input type="email" placeholder="email" ref="loginemail" required @focus="loginFailMessage = ''">
                    <input type="password" placeholder="contraseña" ref="loginpw" required @focus="loginFailMessage = ''">
                    <button v-if="!loginLoad" class="button2" @click="loginUser">Entrar</button>
                    <button v-else class="button2 button-loading"><svg width="12" height="12" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/><path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="button-load--spinner"/></svg></button>
                    <div class="forgot-pw" @click="activeTab = 'forgotpw'">Recuperar contraseña</div>
                    <div v-if="loginFailMessage" class="login-message login-message--fail">
                        {{ loginFailMessage }}
                    </div>
                </div>
                <div v-if="loginSuccesful" class="login-message login-message--success">
                    sesión iniciada con éxito
                </div>
            </div>

            <div class="login-wrap" v-if="activeTab === 'forgotpw'">
                <p style="margin-bottom:1rem;font-weight: 700;font-size: 0.85rem;">Introduce el email registrado en CartaFutbol.</p>
                <input type="email" placeholder="email" ref="recoverpwemail" required>
                <button class="button2" @click="recoverPw">Envíame las instrucciones</button>
            </div>

            <div class="login-wrap" v-if="activeTab === 'resetpw'">
                <p v-if="forgotPwMessage" style="margin-bottom:1rem;font-weight: 700;font-size: 0.85rem;">{{forgotPwMessage}}</p>
                <p style="margin-bottom:1rem;font-weight: 700;font-size: 0.85rem;">Introduce contraseña nueva.</p>
                <input type="email" placeholder="email" ref="resetpwemail" required>
                <input type="password" placeholder="contraseña" ref="resetpwpassword" required>
                <input type="text" ref="resetpwCode" placeholder="código">
                <button class="button2" @click="resetPw">Restablecer contraseña</button>
            </div>

            <div class="login-wrap" v-if="activeTab === 'signup'">
                <!-- <div v-if="!signFailed &&">
                    {{ signUpFailMessage }}
                </div> -->
                
                <div v-if="!signFailed && signUpFailMessage" class="signup-confirmed--mail">
                    <h3>{{ signUpFailMessage }} <span class="signupemail-output">{{ signupEmail }}</span>
                        <br> <span class="smallverify-message">por favor verifica el correo no deseado en caso de no haberlo recibido.</span>
                    </h3>
                    <button class="button2" @click="closeLoginForm">Entendido/cerrar</button>
                </div>
                <div v-else>
                    <input type="text" placeholder="nombre" ref="signupname" required @focus="signUpFailMessage = ''">
                    <input type="email" placeholder="email" ref="signupemail" required @focus="signUpFailMessage = ''">
                    <input type="password" placeholder="contraseña (mínimo 6 caracteres)" ref="signuppw" required @focus="signUpFailMessage = ''">
                    <button class="button2" @click="registerUser">Registrarse</button>
                    <div v-if="signUpFailMessage">{{ signUpFailMessage }}</div>
                </div>
            </div>


        </div>

    </div>

</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            activeTab: 'login',
            loginLoad: false,
            loginSuccesful: false,
            loginFailMessage: '',
            signUpFailMessage: '',
            signFailed: false,
            signupEmail: '',
            forgotPwMessage: ''
        }
    },

    methods: {

        // LOG IN USER
        async loginUser() {

            this.loginLoad = true;
            let email = this.$refs.loginemail.value,
                password = this.$refs.loginpw.value;
            
                const formData = new FormData();

                formData.append('email', email);
                formData.append('password', password);

                const response = await axios.post('https://www.cartafutbol.com/api/v1/User/login.php', formData);

                // Check the response from the server
                if (JSON.parse(response.data.success)) {
                    // Handle success: User registration successful

                    this.loginSuccesful = true;

                    // get user data
                    this.$store.state.loggedIn = true;
                    this.$store.state.user.userName = response.data.user.userName;
                    this.$store.state.user.email = response.data.user.email;
                    this.$store.state.user.tokenId = response.data.jwt;

                    // get user tokens
                    this.$store.state.user.availableTokens = Number(response.data.user.availableTokens);
                    console.log(this.$store.state.user.availableTokens);

                    // get user templates
                    this.$emit('getTemplatesFromDb');

                    // get user saved cards
                    this.$emit('updateMisCartas');

                    this.$emit('addDataLocalStorage');

                    let vm = this;
                    
                    setTimeout(()=> {
                        vm.loginLoad = false;
                        vm.loginSuccesful = false;
                        vm.closeLoginForm();
                    }, 2500);
                    

                } else {
                //     // Handle failure: User registration failed
                    console.warn('User login failed. Reason:', response.data.message);
                    this.loginFailMessage = response.data.message;

                }

                this.loginLoad = false;

        },

        

        async recoverPw() {
            let email = this.$refs.recoverpwemail.value;

            const formData = new FormData();

            formData.append('email', email);

            const response = await axios.post('https://www.cartafutbol.com/api/v1/User/forgot_password.php', formData);

            // Check the response from the server
            if (JSON.parse(response.data.success)) {
                // Handle success: User registration successful
                console.log(response)
                console.log(response.data.message);
                this.forgotPwMessage = 'Correo enviado con el código.';
                this.activeTab = 'resetpw';

            } else {
            //     // Handle failure: User registration failed
                 alert('Se ha reproducido un error: ', response.data.message);
            }
        },

        async resetPw() {
            let email = this.$refs.resetpwemail.value,
                pw = this.$refs.resetpwpassword.value,
                codigo = this.$refs.resetpwCode.value;

            const formData = new FormData();

            formData.append('email', email);
            formData.append('resetCode', codigo);
            formData.append('password', pw);

            const response = await axios.post('https://www.cartafutbol.com/api/v1/User/reset.php', formData);

            // Check the response from the server
            if (JSON.parse(response.data.success)) {
                // Handle success: User registration successful
                console.log(response)
                console.log(response.data.message);
                alert('contraseña actualizada.');
                this.activeTab = '';
                this.forgotPwMessage = '';
                this.closeLoginForm();

            } else {
            //     // Handle failure: User registration failed
                 console.error('Reset pw failed. Reason:', response.data.message);
                 alert(`Se ha reproducido un error: ${response.data.message}`)
            }
        },

        async registerUser() {
            let name = this.$refs.signupname.value,
                email = this.$refs.signupemail.value,
                pw = this.$refs.signuppw.value;
            
            this.signupEmail = email;

            const formData = new FormData();

            formData.append('name', name);
            formData.append('email', email);
            formData.append('password', pw);

            const response = await axios.post('https://www.cartafutbol.com/api/v1/User/signup.php', formData);

            

            // Check the response from the server
            if (JSON.parse(response.data.success)) {
                // Handle success: User registration successful
                console.log('User registered successfully!');
                this.signUpFailMessage = response.data.message;
                this.signFailed = false;
                let vm = this;
                setTimeout(()=>{
                    vm.signUpFailMessage = '';
                    vm.closeLoginForm()
                }, 200000);
                
            } else {
            //     // Handle failure: User registration failed
                 console.warn('User registration failed. Reason:', response.data.message);
                 this.signUpFailMessage = response.data.message;
                 this.signFailed = true;
            }


        },
        closeLoginForm() {
            this.$emit('closeLoginForm')
        }
    }
    
}
</script>

<style lang="less">
.login-signup--wrap {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: var(--overlay_bg);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 1rem;
    z-index: 1000;
    overflow: auto;
}

.log-sig-form {
    background: white;
    border: 1px solid black;
    padding: 3rem 2rem 3rem;
    width: 100%;
    max-width: 550px;
    border-radius: var(--radius_global);
    margin: auto;
    position: relative;
    box-shadow: var(--modal_boxshadow);

    input {
        margin-bottom: 1rem;
    }
}

.log-sig-tab {
    display: flex;
    justify-content: space-evenly;
    margin-bottom: 2rem;

    h3 {
        font-weight: 600;
        font-size: 1.25rem;
        cursor: pointer;

        &.active {
            color: var(--blue_main)
        }
    }
}

.close-loginsignup {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    svg {
        width: 2rem;
        height: auto;
    }
}

.forgot-pw {
    font-weight: 700;
    font-size: 0.85rem;
    display: inline-block;
    margin-left: 2rem;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        text-decoration: none;
    }
}

.button-load--spinner { 
    transform-origin:center;
    animation:buttonSpinnerAnimation .75s infinite linear;


}
@keyframes buttonSpinnerAnimation{
    100%{transform:rotate(360deg)}
}

.button-loading {
    padding: 0.5rem;
    width: 62px;
    height: 39.5px;
    pointer-events: none;

    svg {
        height: auto;
        width: 23px;
        fill: #555;
    }
}

.login-message {
    font-weight: 600;
    font-size: 0.85rem;
    margin: 1rem 0;

    &.login-message--fail {
        color: red;
    }

    &.login-message--success {
        text-align: center;
    }
}

.signup-confirmed--mail {
    text-align: center;
    
    h3 {
        font-size: 1rem;
        font-weight: 700;
        margin-bottom: 2rem;
        line-height: 2;

        span {
            display: block;
        }

        .signupemail-output {
            text-align: center;
            font-size: 1rem;
            font-weight: 400;
            line-height: 3;
        }

        .smallverify-message {
            font-size: 0.85rem;
            font-weight: 500;
            line-height: 1.5;
        }
    }

    
}

</style>